import { PaletteSettings } from '@progress/kendo-angular-inputs';

export const BizzColorPaletteSettings: PaletteSettings = {
  columns: 9,
  palette: [
    //blue:
    '#d9f0ff',
    '#94d6f7',
    '#66c6f2',
    '#43b7ed',
    '#139cd8',
    '#0c84c9',
    '#066fba',
    '#025fab',
    '#004d99',
//green
    '#dfffd1',
    '#b2f794',
    '#83e857',
    '#57c728',
    '#3fad10',
    '#37a10a',
    '#2d8c04',
    '#267a02',
    '#206b00',
//red
    '#ffe4e3',
    '#fa9491',
    '#f56762',
    '#ed3f39',
    '#de1b14',
    '#d1140d',
    '#bd0c05',
    '#9c0803',
    '#800400',
//orange
    '#FFDDCC',
    '#FAB593',
    '#F79260',
    '#ED7437',
    '#E85B15',
    '#CF4D0C',
    '#BD4306',
    '#A33903',
    '#8F3000',
//purple
    '#f2e3ff',
    '#ca93fa',
    '#b86ff7',
    '#9f43f0',
    '#8015de',
    '#710dc9',
    '#6609b8',
    '#5905a3',
    '#49008a',
//yellow
    '#fff8d6',
    '#fae996',
    '#f7dd65',
    '#edce42',
    '#e3bd14',
    '#d4a90d',
    '#bf9106',
    '#9c7003',
    '#825700',
//teal:
    '#d6fffb',
    '#96faf0',
    '#64f5e6',
    '#42ebda',
    '#14d9c5',
    '#0ec7b4',
    '#09b2a2',
    '#039c8c',
    '#008275'
  ],
  tileSize: 25
};
